import type {
	ItemResponse,
	OriginalItemTypes,
	ToeicArtifactType,
} from "@memorang/types";

const aiItemTypes = new Set<OriginalItemTypes>([
	"ASQSW",
	"DISW",
	"FIBDDR",
	"FIBDPR",
	"FIBTIL",
	"HIWL",
	"RASW",
	"RLSW",
	"ROPR",
	"RSSW",
	"RTSSW",
	"SGDL",
	"SSTL",
	"SWTR",
	"WEMSW",
	"WESW",
	"WFDL",
	"WFDL_CORE",
	"ASQSW_CORE",
	"DISW_CORE",
	"FIBDDR_CORE",
	"FIBDPR_CORE",
	"FIBTIL_CORE",
	"HIWL_CORE",
	"RASW_CORE",
	"ROPR_CORE",
	"RSSW_CORE",
	"RTSSW_CORE",
	"SSTL_CORE",
	"SWTR_CORE",
	"WEMSW_CORE",
	"HCSL",
	"HCSL_CORE",
]);

const nonAiItemTypes = new Set<OriginalItemTypes>(["WFDL", "WFDL_CORE"]);

export const isNonAiItemType = (itemType?: OriginalItemTypes): boolean =>
	itemType != null && nonAiItemTypes.has(itemType);

export const isAiSubmittable = (
	responseType: ItemResponse["type"] | undefined,
	itemType?: OriginalItemTypes,
	toeicArtifactType?: ToeicArtifactType,
	hasFeedback?: boolean,
): boolean => {
	if (itemType != null && aiItemTypes.has(itemType)) {
		return true;
	}
	if (hasFeedback) {
		return false;
	}
	if (
		toeicArtifactType === "TEXT_COMPLETION" ||
		toeicArtifactType === "TALKS"
	) {
		return false;
	}
	if (isNonAiItemType(itemType)) {
		return false;
	}
	return (
		responseType === "form" ||
		responseType === "recording" ||
		responseType === "writing" ||
		responseType === "RECORDED_AUDIO" ||
		responseType === "EXTENDED_TEXT" ||
		responseType === "SHORT_TEXT_ENTRY" ||
		responseType === "TOKEN_MAPPING" ||
		responseType === "INLINE_TEXT_SELECTION" ||
		responseType === "ORDER_RECONSTRUCTION" ||
		responseType === "INLINE_OPTION_SELECTION"
	);
};
